export interface General_Group_Interface {
  id:number,
  title:String,

  group_id:Number,
  group_Title:String,

  code:string,
  del:boolean,
  DeletingProccess:boolean
}

export function Empty_General_Group_Interface():General_Group_Interface{
  return{
    id:0,
    title:'',

    group_id:0,
    group_Title:'',

    code:'',
    del:false,
    DeletingProccess:false
  }
}
